const IDs_WHISP = {
  ALTO: 1,
  MEDIO: 2,
  BAJO: 3,
  FALTA_INFORMACION: 4,
  SIN_ASIGNAR: 5,
};

export default IDs_WHISP;
